export const storageInsuranceValueToStr = {
  '0': 'Every package is automatically covered up to $100',
  '0.1': 'Insure $0.1/package/day, every package is covered up to $200',
  '0.2': 'Insure $0.2/package/day, every package is covered up to $300',
  '0.3': 'Insure $0.3/package/day, every package is covered up to $400',
  '0.4': 'Insure $0.4/package/day, every package is covered up to $500',
  '0.5': 'Insure $0.5/package/day, every package is covered up to $600',
  '0.6': 'Insure $0.6/package/day, every package is covered up to $700',
  '0.65': 'Insure $0.65/package/day, every package is covered up to $750',
};
